export const EXSBREASON_DELETE_RESET = 'EXSBREASON_DELETE_RESET'
export const EXSBREASON_DELETE_SET_ERROR = 'EXSBREASON_DELETE_SET_ERROR'
export const EXSBREASON_DELETE_SET_DELETED = 'EXSBREASON_DELETE_SET_DELETED'
export const EXSBREASON_DELETE_TOGGLE_LOADING = 'EXSBREASON_DELETE_TOGGLE_LOADING'
